import classnames from "classnames";
import { DraftHandleValue, Editor, EditorProps } from "draft-js";
import { useRef } from "react";

import { makeStyles } from "@material-ui/core";

import {
  AllowedCommand,
  Toolbar
} from "src/pages/CampaignDetails/Questions/TextEditor/Toolbar";
import { useFormInputStyles } from "src/styles/forms";

import FormTextField from "./FormTextField";

const useStyles = makeStyles(() => ({
  editorWrapper: {
    minHeight: "40px",
    boxSizing: "content-box",
    lineHeight: "2",
    width: "100%"
  },
  root: {
    width: "100%"
  }
}));

export default function FormDraftEditor({
  editorState,
  enableRichText,
  onChange,
  onStyleToggle,
  ...props
}: EditorProps & {
  onStyleToggle: (command: string, type: AllowedCommand) => DraftHandleValue;
  label?: string;
  enableRichText: boolean;
}): JSX.Element {
  const formInputStyles = useFormInputStyles();
  const classes = useStyles();

  const editorRef = useRef<Editor>(null);

  return (
    <div
      className={classnames(formInputStyles.editorInput, classes.editorWrapper)}
    >
      {enableRichText && (
        <Toolbar editorState={editorState} onCommandClick={onStyleToggle} />
      )}
      <FormTextField
        classes={{ root: classes.root }}
        InputProps={{
          inputComponent: () => (
            <div
              style={{
                padding: "12px 10px",
                width: "100%"
              }}
              onClick={() => editorRef.current?.focus()}
            >
              <Editor
                editorState={editorState}
                onChange={onChange}
                {...props}
                ref={editorRef}
              />
            </div>
          )
        }}
      />
    </div>
  );
}
